import React, { useState, useEffect } from "react";
import logo from "../logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    "Home",
    "About",
    "Services",
    "Solutions",
    "Case Studies",
    "Insights",
  ];

  const scrollToSection = (id) => {
    const sectionId = id.toLowerCase().replace(" ", "-");
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsOpen(false);
    } else if (id === "Home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsOpen(false);
    }
  };

  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        width: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(8px)",
        zIndex: 50,
        transition: "all 0.3s",
        boxShadow: scrolled
          ? "0 10px 25px rgba(0,0,0,0.1)"
          : "0 1px 3px rgba(0,0,0,0.1)",
      }}
    >
      <div className="container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "80px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <img
              src={logo}
              alt="IngeniousTech Logo"
              style={{ height: "80px", width: "120" }}
            />
            <span
              style={{ fontWeight: "bold", fontSize: "20px", color: "#0C1A36" }}
            >
              Ingenious<span style={{ color: "#1746A2" }}>Tech</span>
            </span>
          </div>

          <div
            className="desktop-nav"
            style={{ display: "flex", alignItems: "center", gap: "32px" }}
          >
            {navLinks.map((link) => (
              <button
                key={link}
                onClick={() => scrollToSection(link)}
                className="nav-link"
                style={{ color: "#0C1A36", fontWeight: 500 }}
              >
                {link}
              </button>
            ))}
            <button
              onClick={() => scrollToSection("contact")}
              className="btn-primary"
            >
              Contact Us
            </button>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="mobile-menu-btn"
            style={{
              display: "none",
              background: "transparent",
              border: "none",
              color: "#0C1A36",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            <i className={`fas ${isOpen ? "fa-times" : "fa-bars"}`}></i>
          </button>
        </div>
      </div>

      {isOpen && (
        <div
          className="mobile-menu"
          style={{
            backgroundColor: "white",
            borderTop: "1px solid #e5e7eb",
            padding: "16px",
          }}
        >
          {navLinks.map((link) => (
            <button
              key={link}
              onClick={() => scrollToSection(link)}
              style={{
                display: "block",
                width: "100%",
                textAlign: "left",
                padding: "12px 0",
                color: "#0C1A36",
                fontWeight: 500,
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              {link}
            </button>
          ))}
          <button
            onClick={() => scrollToSection("contact")}
            className="btn-primary"
            style={{
              width: "100%",
              justifyContent: "center",
              marginTop: "12px",
            }}
          >
            Contact Us
          </button>
        </div>
      )}

      <style>{`
                @media (min-width: 768px) {
                    .desktop-nav { display: flex !important; }
                    .mobile-menu-btn { display: none !important; }
                }
                @media (max-width: 767px) {
                    .desktop-nav { display: none !important; }
                    .mobile-menu-btn { display: block !important; }
                }
            `}</style>
    </nav>
  );
};

export default Navbar;
